import { AgentBaseInfo } from '@agents/models/agent-base-info';

export class AgentsState {
    agents: AgentBaseInfo[] = [];
}